import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';

import { isIos } from '@utils/device';

import { browser } from '$app/environment';

const reasons: Set<string> = new Set<string>();
/**
 * @description
 * https://github.com/willmcpo/body-scroll-lock/issues/261
 * body-scroll-lock package doesn't add right: 0 on iOS devices and it is
 * cause bug with body width while scroll disabled
 */
export function lockBodyScroll(reason: string) {
    if (browser) {
        reasons.add(reason);
        if (reasons.size > 1) {
            return;
        }
        if (!isIos()) {
            disableBodyScroll(document.body);
        }

        const allowTouchMove = (element: HTMLElement | Element): boolean => {
            while (element && element !== document.body) {
                if (Object.keys((element as HTMLElement).dataset).includes('bodyscrollignore')) {
                    return true;
                }

                element = element.parentElement as HTMLElement;
            }
            return false;
        };
        disableBodyScroll(document.body, { allowTouchMove });
    }
}

export function unlockBodyScroll(reason: string) {
    if (browser) {
        reasons.delete(reason);
        if (!reasons.size) {
            clearAllBodyScrollLocks();
        }
    }
}
